import { ActionType } from "../../../../../react-core/Flux/ActionType";
import { BaseStore } from "../../../../../react-core/Flux/BaseStore";
import { ServiceProposition } from "../../../../../Wrap/Constants/Enums/ServiceProposition";
import { CompanyServicePropositionDispatcher } from "./Variable";

interface ICompanyServicePropositionStoreStaticState {
    isLoading?: boolean;
    actionType: ActionType;
    data?: Array<ServiceProposition>;
}

export class CompanyServicePropositionStoreStatic extends BaseStore<ICompanyServicePropositionStoreStaticState> {
    constructor() {
        super();
        this.subscribeToDispatcher(CompanyServicePropositionDispatcher, (actionData) =>
            this.onCompanyServicePropositionStoreResponse(actionData)
        );
    }

    public getLastResult(): ICompanyServicePropositionStoreStaticState {
        return this.getState();
    }

    public isLoading(): boolean {
        return this.getState().isLoading;
    }

    public getData() {
        return this.getState().data;
    }

    public getActionType() {
        return this.getState().actionType;
    }

    protected getDefaultState(): ICompanyServicePropositionStoreStaticState {
        return {
            actionType: ActionType.Loading,
            data: null,
            isLoading: false,
        };
    }

    private onCompanyServicePropositionStoreResponse(actionData): void {
        switch (actionData.actionType) {
            case ActionType.Success:
                this.setState({ actionType: ActionType.Success, data: actionData.payload });
                break;
            case ActionType.Error:
                this.setState({ actionType: ActionType.Error });
                break;
            case ActionType.Loading:
                this.setState({ isLoading: actionData.payload, actionType: ActionType.Loading });
                break;
        }
    }
}
